import {PageTitle} from "@components/page-title/page-title";
import { ContentContainer } from "@components/utility/content-container.styled";
import React from "react";
import {t} from "i18next";

export default function DocumentsIndex() {


	return (
		<ContentContainer style={{marginTop: '20px'}}>
			<PageTitle title={t('common.sidebar.documents')} />

			<iframe
				style={{
					width: '100%',
					marginTop: '10px',
					maxHeight: '100%',
					height: 'calc(100dvh - 160px)'
				}}
				src={'https://cms.stan-shop.org/stanworks-documentation/'}
			/>
		</ContentContainer>
	)
}